import { create } from "zustand";
import { getAcademicTerms } from "../../services/academicTerm/academicTermServie";

const isCurrentTerm = (term) => {
  if (!term) return false;
  const flag = term.current ?? term.is_current ?? term.isCurrent;
  if (typeof flag === "string") {
    return flag.toLowerCase() === "true" || flag === "1";
  }
  return Boolean(flag);
};

export const useAcademicTermsStore = create((set) => ({
  academicTerms: [],
  current: null,
  isLoading: false,
  error: null,

  fetchAcademicTerms: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await getAcademicTerms();
      // Handle both array and object with results property
      const terms = Array.isArray(data) ? data : data?.results || [];
      const currentTerm = terms.find(isCurrentTerm) || terms[0] || null;
      set({ academicTerms: terms, current: currentTerm, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
      console.error("Error fetching academic terms:", error);
    }
  },

  setAcademicTerms: (academicTerms) => set({ academicTerms }),
  setCurrent: (current) => set({ current }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));

// True once there is nothing left to wait for: the terms are here, or the
// request failed and never will bring them. Pages use it to decide when a
// term-based filter can be resolved - waiting on `academicTerms.length` alone
// would hang forever if the request fails.
export const useAcademicTermsReady = () =>
  useAcademicTermsStore(
    (state) => state.academicTerms.length > 0 || Boolean(state.error)
  );
